import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { StockAmount } from '../../types/stock-amount';
import { FormatPipe } from '@softline/ui-core';

@Component({
  selector: 'soft-stock-amount',
  imports: [FormatPipe],
  templateUrl: './stock-amount.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './stock-amount.component.css',
})
export class StockAmountComponent {
  stockAmount = input.required<StockAmount>();

  readonly hideUnit = input(false);
}
